// extracted by mini-css-extract-plugin
export default {"container":"PercentField_container__D3SKs","input":"PercentField_input__AdUvP","icon":"PercentField_icon__lvshF"};